<div class="row">
  <div class="text-center my-5" *ngIf="isGettingCisterna">
    <app-spinner
      [message]="
        editMode ? 'Cargando detalles del equipo' : 'Cargando formulario'
      "
    ></app-spinner>
  </div>
  <div class="col-xs-12" *ngIf="!isGettingCisterna">
    <h3>
      {{ editMode ? "Actualizar Documentos de la" : "Nueva" }} {{ entityName }}
    </h3>
    <form [formGroup]="cisternaForm" (ngSubmit)="onSubmit()">
      <div *ngIf="!editMode">
        <div class="container-fluid">
          <h4>
            Transportista
            <span *ngIf="!editMode" class="text-danger fs-4">*</span>
          </h4>
          <div class="row">
            <div class="col-sm">
              <div class="form-group">
                <select
                  *ngIf="isCarrier"
                  id="cisterna-carrier"
                  formControlName="carrier"
                  class="form-select"
                >
                  <option [value]="carrierValueId()" selected>
                    {{ carrierValueToDisplay() }}
                  </option>
                </select>
                <select
                  *ngIf="isAdmin"
                  id="cisterna-select-carrier"
                  formControlName="carrier"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let carrier of master.CARRIERS"
                    [ngValue]="carrier.valueId"
                  >
                    {{ carrier.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div id="cisterna-container" class="container-fluid">
          <h4 id="cisterna-title">{{ entityName }}</h4>
          <div class="row">
            <div class="col-sm">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  flex-direction: row;
                "
              >
                <label
                  id="cisterna-license-plate-title"
                  for="licensePlate"
                  class="form-label"
                  >Patente
                  <span *ngIf="!editMode" class="text-danger fs-4">*</span>
                </label>
                <div *ngIf="business === 'FOREIGN'" class="dc-switch-container">
                  <label class="dc-switch-text">Patente Extranjera</label>
                  <label class="dc-switch">
                    <input
                      [disabled]="disableLicensePlate()"
                      checked="PlateForForeing"
                      (change)="changePlateForForeing($event)"
                      type="checkbox"
                    />
                    <span class="dc-slider round"></span>
                  </label>
                </div>
              </div>
              <div class="form-group">
                <input
                  type="text"
                  id="cisterna-licensePlate-input"
                  formControlName="licensePlate"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: {{
                    business === 'FOREIGN' && PlateForForeing === true
                      ? '1234-ABC'
                      : 'AABB00'
                  }}"
                  appInputUppercase
                />
                <div *ngIf="showHelper(cisternaForm.get('licensePlate'))">
                  <small class="form-text text-muted">
                    {{ helperMessages(cisternaForm.get("licensePlate")) }}
                  </small>
                </div>
              </div>
            </div>
            <div class="col-sm">
              <label for="center" class="form-label"
                >Centro
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="center"
                  formControlName="center"
                  class="form-select"
                  (change)="onCisternaCenterChange()"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let center of master.CENTERS"
                    [ngValue]="center.valueId"
                  >
                    {{ center.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div id="cisterna-sub-business" *ngIf="!isForeign()" class="row">
            <div class="col-sm">
              <label
                id="cisterna-sub-business-title"
                for="subBusiness"
                class="form-label"
                >Sub-negocio
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="cisterna-subBusiness-select"
                  formControlName="subBusiness"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let subBusiness of master['SUB_BUSINESSES']"
                    [ngValue]="subBusiness.valueId"
                  >
                    {{ subBusiness.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2">
            <div id="cisterna-brand" class="col-sm">
              <label id="cisterna-brand-title" for="brand" class="form-label"
                >Marca
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="cisterna-brand-select"
                  formControlName="brand"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let brand of master['VEHICLES#BRANDS']"
                    [ngValue]="brand.valueId"
                  >
                    {{ brand.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
            <div id="cisterna-model" class="col-sm">
              <label id="cisterna-model-title" for="model" class="form-label"
                >Modelo
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <input
                  type="text"
                  id="cisterna-model-select"
                  formControlName="model"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: Volvo FH"
                  appInputTrim
                />
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2">
            <div id="cisterna-year" class="col-sm">
              <label id="cisterna-year-label" for="year" class="form-label"
                >Año de Fabricación
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <input
                  type="number"
                  id="cisterna-year-select"
                  formControlName="year"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 2020"
                  (change)="onCisternaYearChange()"
                />
              </div>
            </div>
            <div id="cisterna-color" class="col-sm">
              <label id="cisterna-color-label" for="color" class="form-label"
                >Color
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="cisterna-color-select"
                  formControlName="color"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let color of master['VEHICLES#COLORS']"
                    [ngValue]="color.valueId"
                  >
                    {{ color.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid border rounded p-2 my-2">
          <div class="row">
            <div class="col-sm">
              <div class="container-fluid">
                <div class="row">
                  <div id="cisterna-volume" class="col-sm">
                    <label
                      id="cisterna-volume-title"
                      for="volume"
                      class="form-label"
                      >Volumen
                      <span *ngIf="!editMode" class="text-danger fs-4"
                        >*</span
                      ></label
                    >
                    <div class="form-group">
                      <select
                        *ngIf="business !== 'FOREIGN'"
                        id="cisterna-volume-select"
                        formControlName="volume"
                        class="form-select"
                        (change)="onCisternaVolumeChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let volume of cisternasVolumes"
                          [ngValue]="volume.valueId"
                        >
                          {{ volume.valueToDisplay }}
                        </option>
                      </select>
                      <select
                        *ngIf="business === 'FOREIGN'"
                        id="cisterna-volume-select"
                        formControlName="volume"
                        class="form-select"
                        (change)="onCisternaVolumeChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let volume of foreingVolumen"
                          [ngValue]="volume"
                        >
                          {{ volume }} m3
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div id="cisterna-container-number" class="col-sm">
                    <label
                      id="cisterna-container-number-title"
                      for="containersNumber"
                      class="form-label"
                      >Número de Compartimentos
                      <span *ngIf="!editMode" class="text-danger fs-4"
                        >*</span
                      ></label
                    >
                    <div class="form-group">
                      <select
                        *ngIf="business !== 'FOREIGN'"
                        id="cisterna-containersNumber-select"
                        formControlName="containersNumber"
                        class="form-select"
                        (change)="onCisternaContainersNumberChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="
                            let containersNumber of cisternasContainersNumbers
                          "
                          [ngValue]="containersNumber.valueId"
                        >
                          {{ containersNumber.valueToDisplay }}
                        </option>
                      </select>
                      <select
                        *ngIf="business === 'FOREIGN'"
                        id="cisterna-containersNumber-select"
                        formControlName="containersNumber"
                        class="form-select"
                        (change)="onCisternaContainersNumberChange()"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let containersNumber of foreingCompartiments"
                          [ngValue]="containersNumber"
                        >
                          {{ containersNumber }} Compartimentos
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div id="cisterna-capacity" class="col-sm">
                    <label
                      id="cisterna-capacity-label"
                      for="capacity"
                      class="form-label"
                      >Capacidad
                      <span *ngIf="!editMode" class="text-danger fs-4"
                        >*</span
                      ></label
                    >
                    <div class="form-group" *ngIf="business !== 'FOREIGN'">
                      <select
                        id="cisterna-capacity-select"
                        formControlName="capacity"
                        class="form-select"
                      >
                        <option value="" selected>Seleccionar...</option>
                        <option
                          *ngFor="let capacity of cisternasCapacities"
                          [ngValue]="capacity.valueId"
                        >
                          {{ capacity.valueToDisplay }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="form-group capacity-container"
                      *ngIf="business === 'FOREIGN'"
                      formArrayName="capacity"
                    >
                      <div
                        *ngFor="let item of range; let i = index"
                        class="capacity-secction"
                      >
                        <div class="position-relative">
                          <input
                            id="cisterna-capacity-input"
                            type="number"
                            class="form-control"
                            step="0.01"
                            [formControlName]="i"
                            (input)="onInputChange(i)"
                            (blur)="hideSuggestions(i)"
                            placeholder="10.00"
                          />

                          <ul
                            class="list-group position-absolute w-100"
                            *ngIf="
                              filteredSuggestions[i]?.length &&
                              showSuggestions[i]
                            "
                            style="
                              z-index: 10;
                              max-height: 200px;
                              overflow-y: auto;
                            "
                          >
                            <li
                              class="list-group-item list-group-item-action"
                              *ngFor="let suggestion of filteredSuggestions[i]"
                              (mousedown)="selectSuggestion(i, suggestion)"
                            >
                              {{ suggestion }}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="cisterna-capacity-image"
              class="col-sm text-center"
              *ngIf="business !== 'FOREIGN'"
            >
              <app-tanker
                [totalVolume]="volumeToDisplay"
                [compartments]="capacitiesDisplay"
              ></app-tanker>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm">
              <label for="bulkheadType" class="form-label"
                >Tipo de Mamparo
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="bulkheadType"
                  formControlName="bulkheadType"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let bulkhead of master['CISTERNAS#BULKHEAD_TYPES']"
                    [ngValue]="bulkhead.valueId"
                  >
                    {{ bulkhead.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm">
              <label for="engineType" class="form-label"
                >Tipo de Motor
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <select
                  id="engineType"
                  formControlName="engineType"
                  class="form-select"
                >
                  <option value="" selected>Seleccionar...</option>
                  <option
                    *ngFor="let engine of master['CISTERNAS#ENGINE_TYPES']"
                    [ngValue]="engine.valueId"
                  >
                    {{ engine.valueToDisplay }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="business === 'FUELS'" class="container-fluid">
          <div class="row my-2">
            <div id="cisterna-usos" class="col-sm">
              <label class="form-label"
                >Usos
                <span *ngIf="!editMode" class="text-danger fs-4">*</span></label
              >
              <div class="form-group">
                <app-multi-select
                  placeholder="Seleccione Usos."
                  [formControl]="usesControl"
                  [options]="multiOpts"
                ></app-multi-select>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid">
          <div class="row my-2 align-items-center">
            <div
              id="cisterna-forMining"
              class="col-sm text-center border rounded mx-1"
            >
              <p id="cisterna-forMining-text" class="pt-1">
                Usado en minería
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-forMiningYes"
                  formControlName="forMining"
                  class="form-check-input"
                  value="true"
                />
                <label for="forMiningYes" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-forMiningNo"
                  formControlName="forMining"
                  class="form-check-input"
                  value="false"
                />
                <label for="forMiningNo" class="form-check-label">No</label>
              </div>
            </div>
            <div
              id="cisterna-RanchAccreditation"
              class="col-sm text-center border rounded mx-1"
            >
              <p id="cisterna-RanchAccreditation-text" class="pt-1">
                Tiene Acreditación Ranchera
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-hasRanchAccreditationYes"
                  formControlName="hasRanchAccreditation"
                  class="form-check-input"
                  value="true"
                />
                <label for="hasRanchAccreditationYes" class="form-check-label"
                  >Sí</label
                >
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-hasRanchAccreditationNo"
                  formControlName="hasRanchAccreditation"
                  class="form-check-input"
                  value="false"
                />
                <label for="hasRanchAccreditationNo" class="form-check-label"
                  >No</label
                >
              </div>
            </div>
            <div
              id="cisterna-pump"
              class="col-sm text-center border rounded mx-1"
            >
              <p id="cisterna-pump-text" class="pt-1">
                Tiene Bomba
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-hasPumpYes"
                  formControlName="hasPump"
                  class="form-check-input"
                  value="true"
                />
                <label for="hasPumpYes" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-hasPumpNo"
                  formControlName="hasPump"
                  class="form-check-input"
                  value="false"
                />
                <label for="hasPumpNo" class="form-check-label">No</label>
              </div>
            </div>
            <div
              id="cisterna-Spot"
              class="col-sm text-center border rounded mx-1"
            >
              <p id="cisterna-Spot-text" class="pt-1">
                Es Spot
                <span *ngIf="!editMode" class="text-danger fs-4">*</span>
              </p>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-isSpotYes"
                  formControlName="isSpot"
                  class="form-check-input"
                  value="true"
                />
                <label for="isSpotYes" class="form-check-label">Sí</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  type="radio"
                  id="cisterna-isSpotNo"
                  formControlName="isSpot"
                  class="form-check-input"
                  value="false"
                />
                <label for="isSpotNo" class="form-check-label">No</label>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row my-2">
            <div id="cisterna-gpsImei" class="col-sm">
              <label id="cisterna-gpsImei-text" for="gpsImei" class="form-label"
                >GPS IMEI</label
              >
              <div class="form-group">
                <input
                  type="text"
                  id="cisterna-gpsImei-input"
                  formControlName="gpsImei"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 123456789012345"
                  appInputTrim
                />
              </div>
            </div>
            <div id="cisterna-cameraImei" class="col-sm">
              <label
                id="cisterna-cameraImei-text"
                for="cameraImei"
                class="form-label"
                >Cámara IMEI</label
              >
              <div class="form-group">
                <input
                  type="text"
                  id="cisterna-cameraImei-input"
                  formControlName="cameraImei"
                  class="form-control immutable-field"
                  placeholder="Ejemplo: 123456789012345"
                  appInputTrim
                />
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="business === 'FUELS'">
          <div class="container-fluid">
            <div class="row my-2">
              <div id="cisterna-SECCertificate" class="col-sm">
                <label
                  id="cisterna-SECCertificate-text"
                  for="SECCertificate"
                  class="form-label"
                  >N° certificado SEC
                  <span *ngIf="!editMode" class="text-danger fs-4"
                    >*</span
                  ></label
                >
                <div class="form-group">
                  <input
                    type="number"
                    id="cisterna-SECCertificate-input"
                    formControlName="SECCertificate"
                    class="form-control immutable-field"
                    placeholder="Ejemplo: 345678901234567"
                    appInputTrim
                  />
                </div>
              </div>
              <div id="cisterna-SECDate" class="col-sm">
                <label
                  id="cisterna-SECDate-text"
                  for="SECDate"
                  class="form-label"
                  >Fecha de inscripción SEC
                  <span *ngIf="!editMode" class="text-danger fs-4"
                    >*</span
                  ></label
                >
                <div class="form-group">
                  <input
                    type="date"
                    id="cisterna-SECDate"
                    max="{{ maxDate }}"
                    formControlName="SECDate"
                    class="form-control"
                  />
                  <ng-container
                    *ngIf="
                      cisternaForm.controls['SECDate'].hasError('futureDate') &&
                      cisternaForm.controls['SECDate'].touched
                    "
                  >
                    <span
                      >{{ cisternaForm.controls['SECDate'].errors?.['futureDate'] }}</span
                    >
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div class="row my-2">
              <div id="cisterna-SECFolio" class="col-sm">
                <label
                  id="cisterna-SECFolio-text"
                  for="SECFolio"
                  class="form-label"
                  >N° Folio inscripción SEC
                  <span *ngIf="!editMode" class="text-danger fs-4"
                    >*</span
                  ></label
                >
                <div class="form-group">
                  <input
                    type="number"
                    id="cisterna-SECFolio-input"
                    formControlName="SECFolio"
                    class="form-control immutable-field"
                    placeholder="Ejemplo: 234567890123456"
                    appInputTrim
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <hr />
      </div>
      <div class="container-fluid">
        <h5 class="dc-header-title">
          <span>
            <i class="material-symbols-outlined align-middle">description</i>
            Documentos {{ editMode ? "de " + cisternaIdentification : "" }}
          </span>
          <div class="dc-switch-container">
            <label class="dc-switch-text">Mostrar solo obligatorios</label>
            <label class="dc-switch">
              <input type="checkbox" formControlName="onlyMandatory" />
              <span class="dc-slider round"></span>
            </label>
          </div>
        </h5>
        <div class="alert alert-warning" role="alert" *ngIf="!archiveMode">
          <i class="material-symbols-outlined align-middle">warning</i> Solo se
          aceptan documentos en formato PDF.
        </div>
        <div class="alert alert-info" role="alert" *ngIf="archiveMode">
          <i class="material-symbols-outlined align-middle">info</i> Se copiarán
          los documentos del {{ entityName }} anterior.
        </div>
        <div class="col-xs-12" formArrayName="documents" *ngIf="!archiveMode">
          <ng-container
            *ngFor="let documentControl of documentsControl; let i = index"
          >
            <div
              class="row border-top"
              id="cisterna-documents"
              *ngIf="
                isMandatoryDocument(
                  documentControl.get('documentMasterValueId')?.value
                ) || !mandatorySlider
              "
              [formGroupName]="i"
            >
              <div class="row my-2">
                <div class="col-sm-11">
                  <input
                    type="text"
                    id="cisterna-documentName"
                    class="form-control-plaintext form-control-lg"
                    formControlName="documentName"
                    readonly
                  />
                </div>
                <div
                  class="col-sm-1"
                  *ngIf="
                    !editMode &&
                    isMandatoryDocument(
                      documentControl.get('documentMasterValueId')?.value
                    )
                  "
                >
                  <p class="text-danger fs-4">*</p>
                </div>
              </div>
              <div
                *ngIf="
                  editMode &&
                  invalidControl(documentControl.get('documentExpirationDate'))
                "
              >
                <small
                  id="cisterna-document-alert"
                  class="form-text text-danger"
                >
                  Documento vencido, es necesario actualizar.
                </small>
              </div>
              <div
                class="row"
                *ngIf="
                  !isDatelessDocument(
                    documentControl.get('documentMasterValueId')?.value
                  )
                "
              >
                <label
                  id="cisterna-document-date"
                  for="documentIssueDate"
                  class="col-sm-2 col-form-label"
                  >Emisión</label
                >
                <div class="col-sm-4">
                  <input
                    type="date"
                    id="cisterna-documentIssueDate"
                    formControlName="documentIssueDate"
                    class="form-control"
                  />
                  <div
                    *ngIf="showHelper(documentControl.get('documentIssueDate'))"
                  >
                    <small
                      id="cisterna-document-helper"
                      class="form-text text-muted"
                    >
                      {{
                        helperMessages(documentControl.get("documentIssueDate"))
                      }}
                    </small>
                  </div>
                </div>
                <label
                  id="cisterna-documentExpirationDate-text"
                  for="documentExpirationDate"
                  class="col-sm-2 col-form-label"
                  >Vencimiento</label
                >
                <div class="col-sm-4">
                  <input
                    type="date"
                    id="cisterna-documentExpirationDate"
                    formControlName="documentExpirationDate"
                    class="form-control"
                  />
                  <div
                    *ngIf="
                      showHelper(documentControl.get('documentExpirationDate'))
                    "
                  >
                    <small class="form-text text-muted">
                      {{
                        helperMessages(
                          documentControl.get("documentExpirationDate")
                        )
                      }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row my-2">
                <div class="col-sm-12">
                  <input
                    type="file"
                    accept=".pdf"
                    id="cisterna-documentFile"
                    formControlName="documentFile"
                    class="form-control"
                    (change)="onChangeDocumentFile($event, i)"
                  />
                  <div *ngIf="showHelper(documentControl.get('documentFile'))">
                    <small class="form-text text-muted">
                      {{ helperMessages(documentControl.get("documentFile")) }}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-xs-12">
          <button
            id="cisterna-edit-cancel"
            type="button"
            class="btn btn-outline-danger"
            (click)="onCancel()"
          >
            Cancelar
          </button>
          <button
            id="cisterna-edit-show"
            type="button"
            class="btn btn-outline-secondary mx-2"
            (click)="showForm()"
            *ngIf="isDev"
          >
            Log Form
          </button>
          <button
            id="cisterna-edit-submit"
            type="submit"
            class="btn btn-outline-primary mx-2 float-end"
            [disabled]="disableSubmit"
          >
            {{ editMode ? "Actualizar Documentos" : "Crear " + entityName }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
